/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriviaAnswerResponse
 */
export interface TriviaAnswerResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TriviaAnswerResponse
     */
    isCorrect: boolean;
    /**
     * 
     * @type {string}
     * @memberof TriviaAnswerResponse
     */
    explanation?: string;
    /**
     * 0-100 percentage correct
     * @type {number}
     * @memberof TriviaAnswerResponse
     */
    scorePercent: number;
    /**
     * 
     * @type {number}
     * @memberof TriviaAnswerResponse
     */
    correctCount: number;
    /**
     * 
     * @type {number}
     * @memberof TriviaAnswerResponse
     */
    totalQuestions: number;
    /**
     * True when every question has been answered
     * @type {boolean}
     * @memberof TriviaAnswerResponse
     */
    allAnswered: boolean;
    /**
     * True when allAnswered and scorePercent >= passingScore
     * @type {boolean}
     * @memberof TriviaAnswerResponse
     */
    passed: boolean;
    /**
     * Zero-based index of the correct option, so the client can highlight it without isCorrect in the config payload
     * @type {number}
     * @memberof TriviaAnswerResponse
     */
    correctOptionIndex: number;
}

/**
 * Check if a given object implements the TriviaAnswerResponse interface.
 */
export function instanceOfTriviaAnswerResponse(value: object): value is TriviaAnswerResponse {
    if (!('isCorrect' in value) || value['isCorrect'] === undefined) return false;
    if (!('scorePercent' in value) || value['scorePercent'] === undefined) return false;
    if (!('correctCount' in value) || value['correctCount'] === undefined) return false;
    if (!('totalQuestions' in value) || value['totalQuestions'] === undefined) return false;
    if (!('allAnswered' in value) || value['allAnswered'] === undefined) return false;
    if (!('passed' in value) || value['passed'] === undefined) return false;
    if (!('correctOptionIndex' in value) || value['correctOptionIndex'] === undefined) return false;
    return true;
}

export function TriviaAnswerResponseFromJSON(json: any): TriviaAnswerResponse {
    return TriviaAnswerResponseFromJSONTyped(json, false);
}

export function TriviaAnswerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriviaAnswerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isCorrect': json['isCorrect'],
        'explanation': json['explanation'] == null ? undefined : json['explanation'],
        'scorePercent': json['scorePercent'],
        'correctCount': json['correctCount'],
        'totalQuestions': json['totalQuestions'],
        'allAnswered': json['allAnswered'],
        'passed': json['passed'],
        'correctOptionIndex': json['correctOptionIndex'],
    };
}

export function TriviaAnswerResponseToJSON(json: any): TriviaAnswerResponse {
    return TriviaAnswerResponseToJSONTyped(json, false);
}

export function TriviaAnswerResponseToJSONTyped(value?: TriviaAnswerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isCorrect': value['isCorrect'],
        'explanation': value['explanation'],
        'scorePercent': value['scorePercent'],
        'correctCount': value['correctCount'],
        'totalQuestions': value['totalQuestions'],
        'allAnswered': value['allAnswered'],
        'passed': value['passed'],
        'correctOptionIndex': value['correctOptionIndex'],
    };
}

